import axios from "axios";
import { BASE_URL } from "../BaseUrl.js";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("compte_admin");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

//liste des All product

export const statsDashboard = async (page, size, param) => {
  // return await axios.get(`${BASE_URL}/parametres/allCategorie`), {});
  return await axios.get(
    `${BASE_URL}/dashboard`,
    {}
  );
};


